import { render, staticRenderFns } from "./GoalAudienceSettings.vue?vue&type=template&id=02e5ae48&"
import script from "./GoalAudienceSettings.vue?vue&type=script&lang=js&"
export * from "./GoalAudienceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02e5ae48')) {
      api.createRecord('02e5ae48', component.options)
    } else {
      api.reload('02e5ae48', component.options)
    }
    module.hot.accept("./GoalAudienceSettings.vue?vue&type=template&id=02e5ae48&", function () {
      api.rerender('02e5ae48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Goal/GoalAudienceSettings.vue"
export default component.exports